import { useCallback, useState } from "react";

import type { ChangeEvent, FormEvent } from "react";

type Props = {
	onEnterCallback: (value: string) => void;
};

/**
 * @todo 日本語入力の制御
 */
export const TagInputField = ({ onEnterCallback }: Props) => {
	const [value, setValue] = useState<string>("");

	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setValue(value);
	}, []);

	const handleSubmit = useCallback(
		(e: FormEvent<HTMLFormElement>) => {
			e.preventDefault();

			onEnterCallback(value);
			setValue("");
		},
		[onEnterCallback, value],
	);

	return (
		<form onSubmit={handleSubmit}>
			<input
				value={value}
				placeholder="ここに入力後、Enterキーで送信してください"
				className="w-full border-none focus:outline-none"
				onChange={handleChange}
			/>
		</form>
	);
};
